export { rxSocketClient as webSocket } from './lib/rx-socket-client';
export {
    RxSocketClientSubject, RxSocketClientConfig, WebSocketMessage, WebSocketBinaryServer, WebSocketMessageServer
} from './lib/rx-socket-client.subject';
